
const awscognito = {
	Auth: {
		// REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
		identityPoolId: 'ap-southeast-1:1077fe9f-f6ae-4b8e-8740-d0d7bec7f4e6',
        
		// REQUIRED - Amazon Cognito Region
		region: 'ap-southeast-1',

		// OPTIONAL - Amazon Cognito User Pool ID
		userPoolId: 'ap-southeast-1_MyobAFReV',
		// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
		userPoolWebClientId: '7161g4pllgd03h9imiskjbshke',

		// OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
		authenticationFlowType: 'CUSTOM_AUTH',
		

/*
		// OPTIONAL - Configuration for cookie storage
		// Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
		cookieStorage: {
			// REQUIRED - Cookie domain (only required if cookieStorage is provided)
			domain: '.yourdomain.com',
			// OPTIONAL - Cookie path
			path: '/',
			// OPTIONAL - Cookie expiration in days
			expires: 365,
			// OPTIONAL - Cookie secure flag
			// Either true or false, indicating if the cookie transmission requires a secure protocol (https).
			secure: true
		},

		// OPTIONAL - customized storage object
		storage: new MyStorage(),
        
		// OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
		mandatorySignIn: true,

		// OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers
		clientMetadata: { myCustomKey: 'myCustomValue' },

		// OPTIONAL - Hosted UI configuration
		oauth: {
			domain: 'your_cognito_domain',
			scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
			redirectSignIn: 'http://localhost:3000/',
			redirectSignOut: 'http://localhost:3000/',
			responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
		}
*/		
	}
};

export default awscognito;
